import React, { useState, useEffect, useContext } from "react";
import "./UserEditModal.css";
import ProjectAuthTable from "./ProjectAuthTable";
import { useLanguage } from "../../../../../LanguageProvider";
import { TbDeviceFloppy } from "react-icons/tb";
import { GeneralContext } from "../../../../../GeneralProvider";
import { RxCross1 } from "react-icons/rx";

export default function UserEditModal({ user, onClose, collections, panels }) {
  const { getTranslation } = useLanguage();
  const { updateCollaboratorsAuthorizations } = useContext(GeneralContext);
  const isFullAccess =
    user.authorizations.authorizations === "all" &&
    user.authorizations.type === "owner";
  const [role, setRole] = useState(
    isFullAccess ? "owner" : user.authorizations.type
  );

  const [collectionPermissions, setCollectionPermissions] = useState({});
  const [panelPermissions, setPanelPermissions] = useState({});
  const [canSeeKronos, setCanSeeKronos] = useState(
    user?.authorizations.canSeeKronos
  );

  useEffect(() => {

    let updatedCollectionPermissions = {};
    let updatedPanelPermissions = {};

    if (role === "owner") {
      // Eğer rol "owner" ise her şeyi "all" yap
      collections.forEach((entity) => {
        updatedCollectionPermissions[entity.id] = "all";
      });
      panels.forEach((entity) => {
        updatedPanelPermissions[entity.id] = "all";
      });
    } else if (user.authorizations.authorizations === "all") {
      // Eğer kullanıcı owner değilse ama yetkileri "all" ise
      collections.forEach((entity) => {
        updatedCollectionPermissions[entity.id] = "all";
      });
      panels.forEach((entity) => {
        updatedPanelPermissions[entity.id] = "all";
      });
    } else if (role === "employee" || role === "partner") {
      if (isFullAccess) {
        // Eğer full access ise tüm yetkileri "read" veya "all" olarak belirle
        collections.forEach((entity) => {
          updatedCollectionPermissions[entity.id] =
            role === "employee" ? "read" : "all";
        });
        panels.forEach((entity) => {
          updatedPanelPermissions[entity.id] =
            role === "employee" ? "read" : "all";
        });
      } else {
        // Kullanıcının mevcut yetkilerini koru, eksik olanları boş bırak
        collections?.forEach((entity) => {
          const existingAuth = Array.isArray(
            user?.authorizations?.authorizations?.collections
          )
            ? user.authorizations.authorizations.collections.find(
                (auth) => auth.id === entity.id
              )
            : null;

          updatedCollectionPermissions[entity.id] = existingAuth
            ? existingAuth.authorization
            : "";
        });

        panels?.forEach((entity) => {
          const existingAuth = Array.isArray(
            user?.authorizations?.authorizations?.panels
          )
            ? user.authorizations.authorizations.panels.find(
                (auth) => auth.id === entity.id
              )
            : null;

          updatedPanelPermissions[entity.id] = existingAuth
            ? existingAuth.authorization
            : "";
        });

        if (user?.authorizations?.authorizations?.panels === "all") {
          panels.forEach((entity) => {
            updatedPanelPermissions[entity.id] = "all";
          });
        }
        if (user?.authorizations?.authorizations?.collections === "all") {
          collections.forEach((entity) => {
            updatedCollectionPermissions[entity.id] = "all";
          });
        }
      }
    } else {
      // Kullanıcının mevcut yetkilerini koru, eksik olanları boş bırak
      if (user.authorizations.authorizations.collections) {
        user.authorizations.authorizations.collections.forEach((auth) => {
          updatedCollectionPermissions[auth.id] = auth.authorization;
        });
      }
      if (user.authorizations.authorizations.panels) {
        user.authorizations.authorizations.panels.forEach((auth) => {
          updatedPanelPermissions[auth.id] = auth.authorization;
        });
      }
    }

    setCollectionPermissions(updatedCollectionPermissions);
    setPanelPermissions(updatedPanelPermissions);
  }, [role, collections, panels, user.authorizations.authorizations]);

  const handleRoleChange = (selectedRole) => {
    setRole(selectedRole);

    let updatedCollectionPermissions = {};
    let updatedPanelPermissions = {};

    if (selectedRole === "owner") {
      collections.forEach((entity) => {
        updatedCollectionPermissions[entity.id] = "all";
      });
      panels.forEach((entity) => {
        updatedPanelPermissions[entity.id] = "all";
      });
      setCanSeeKronos(true);
    } else if (selectedRole === "employee" || selectedRole === "partner") {
      if (user.authorizations.authorizations.collections === "all") {
        collections.forEach((entity) => {
          updatedCollectionPermissions[entity.id] = "all";
        });
      } else {
        collections.forEach((entity) => {
          const existingAuth =
            user.authorizations.authorizations.collections?.find(
              (auth) => auth.id === entity.id
            );
          updatedCollectionPermissions[entity.id] = existingAuth
            ? existingAuth.authorization
            : "";
        });
      }

      if (user.authorizations.authorizations.panels === "all") {
        panels.forEach((entity) => {
          updatedPanelPermissions[entity.id] = "all";
        });
      } else {
        panels.forEach((entity) => {
          const existingAuth = user.authorizations.authorizations.panels?.find(
            (auth) => auth.id === entity.id
          );
          updatedPanelPermissions[entity.id] = existingAuth
            ? existingAuth.authorization
            : "";
        });
      }
    }
    // else if (selectedRole === "partner") {

    //   collections.forEach((entity) => {
    //     updatedCollectionPermissions[entity.id] = "all";
    //   });
    //   panels.forEach((entity) => {
    //     updatedPanelPermissions[entity.id] = "all";
    //   });
    // }
    else {
      updatedCollectionPermissions = {};
      updatedPanelPermissions = {};
    }

    setCollectionPermissions(updatedCollectionPermissions);
    setPanelPermissions(updatedPanelPermissions);
  };

  const handleSave = () => {
    // Boş olmayan izinleri filtreleme fonksiyonu
    const filterNonEmptyValues = (obj) =>
      Object.keys(obj)
        .filter((id) => obj[id] !== "") // Boş olanları filtrele
        .map((id) => ({ id, authorization: obj[id] }));

    // Filtrelenmiş collection ve panel izinleri
    const formattedCollections = filterNonEmptyValues(collectionPermissions);
    const formattedPanels = filterNonEmptyValues(panelPermissions);

    // Tüm izinlerin "all" olup olmadığını kontrol et
    const countNonEmptyValues = (obj) =>
      Object.values(obj).filter((auth) => auth !== "").length;

    const validCollectionCount = countNonEmptyValues(collectionPermissions);
    const validPanelCount = countNonEmptyValues(panelPermissions);

    const allCollectionsAreAll =
      Object.values(collectionPermissions).every((auth) => auth === "all") &&
      validCollectionCount === collections.length;

    const allPanelsAreAll =
      Object.values(panelPermissions).every((auth) => auth === "all") &&
      validPanelCount === panels.length;

    let updatedAuthorizations;

    if (allCollectionsAreAll && allPanelsAreAll) {
      // Eğer tüm izinler "all" ise, sadece string olarak "all" kaydet
      if (role === "owner") {
        updatedAuthorizations = "all";
      } else {
        updatedAuthorizations = {
          collections: "all",
          panels: "all",
        };
      }
    } else if (allCollectionsAreAll && !allPanelsAreAll) {
      updatedAuthorizations = {
        collections: "all",
        panels: formattedPanels.length > 0 ? formattedPanels : [],
      };
    } else if (!allCollectionsAreAll && allPanelsAreAll) {
      updatedAuthorizations = {
        collections:
          formattedCollections.length > 0 ? formattedCollections : [],
        panels: "all",
      };
    } else {
      // Eğer en az bir tanesi eksikse, nesne olarak kaydet
      updatedAuthorizations = {
        collections:
          formattedCollections.length > 0 ? formattedCollections : [],
        panels: formattedPanels.length > 0 ? formattedPanels : [],
      };
    }

    let updatedCollaborator = {
      type: role,
      authorizations: updatedAuthorizations,
      canSeeKronos: canSeeKronos,
    };

    updateCollaboratorsAuthorizations(user.userID, updatedCollaborator).then(
      () => onClose()
    );

    // Kaydetme işlemi burada yapılabilir
  };

  return (
    <div className="user-edit-modal-overlay">
      <div className="user-edit-modal-content">
        {/* Role Selection */}
        <div className="role-selection">
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              marginRight: "22px",
            }}
          >
            <span className="user-label">{getTranslation("user")}</span>
            <span className="user-edit-name-lastname">
              {user.name + " " + user.lastname}
            </span>
          </div>

          <label>
            <input
              type="radio"
              name="role"
              value="employee"
              checked={role === "employee"}
              onChange={() => handleRoleChange("employee")}
            />
            {getTranslation("employee")}
          </label>

          <label style={{ marginLeft: "15px" }}>
            <input
              type="radio"
              name="role"
              value="partner"
              checked={role === "partner"}
              onChange={() => handleRoleChange("partner")}
            />
            {getTranslation("partner")}
          </label>

          <label style={{ marginLeft: "15px" }}>
            <input
              type="radio"
              name="role"
              value="owner"
              checked={role === "owner"}
              onChange={() => handleRoleChange("owner")}
            />
            {getTranslation("owner")}
          </label>
        </div>

        <div className="kronos-auth-container">
          <input
            type="checkbox"
            checked={canSeeKronos}
            onChange={() => setCanSeeKronos(!canSeeKronos)}
            disabled={role === "owner"}
          />
          <span>{getTranslation("canViewCollaboratorsKronosRecords")}</span>
        </div>

        {/* Collection Table */}
        <span className="user-edit-title">{getTranslation("collections")}</span>
        <ProjectAuthTable
          entities={collections}
          authorizations={Object.keys(collectionPermissions).map((id) => ({
            id,
            authorization: collectionPermissions[id],
          }))} // Boş olanlar burada gelmeyecek
          onPermissionsUpdate={setCollectionPermissions}
          role={role}
        />

        {/* Panel Table */}
        <span className="user-edit-title">{getTranslation("panels")}</span>
        <ProjectAuthTable
          entities={panels}
          authorizations={Object.keys(panelPermissions).map((id) => ({
            id,
            authorization: panelPermissions[id],
          }))} // Boş olanlar burada gelmeyecek
          onPermissionsUpdate={setPanelPermissions}
          role={role}
        />

        {/* Action Buttons */}
        <div
          style={{
            width: "100%",
            marginTop: "15px",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            display: "flex",
            gap: "10px",
          }}
        >
          <button className="user-edit-save-button" onClick={onClose}>
            <RxCross1 size={16} /> {getTranslation("cancel")}
          </button>
          <button className="user-edit-save-button" onClick={handleSave}>
            <TbDeviceFloppy strokeWidth={1} size={20} />{" "}
            {getTranslation("save")}
          </button>
        </div>
      </div>
    </div>
  );
}
